import React, { useState, useEffect } from "react";
import editIcon from "../../../assets/images/editIcon.svg";
import { useNavigate } from "react-router-dom";
import { fetchCategoryById } from "../../../redux/categoriesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

const ReviewCategories = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const categoryDetails =
    useSelector((state) => state.categories.categoryDetails) || {};
  const { categoryId } = useParams();

  // Navigate to the edit category page
  const editCategory = (categoryId) => {
    navigate(`/edit-product-category/${categoryId}`, {state: {
      actionType: 'edit',  // Indicate this is for editing
      categoryDetails,     // Pass the entire category details object
    }, });
  };

  useEffect(() => {
    if (categoryId) {
      dispatch(fetchCategoryById(categoryId));
    }
  }, [dispatch, categoryId]);

  return (
    <>
      <nav aria-label="breadcrumb" className="bread-box">
        <div>
          <h1 className="fprimary">Review Category</h1>
          <h5>Review the category details carefully before proceeding.</h5>
        </div>
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#">Categories</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Review Category
            </li>
          </ol>
        </div>
      </nav>

      <div className="card mt-3 bg-stage">
        {/* Category Details */}
        <div className="card-body">
          <div className="mb-2">
            <h1 className="fprimary">
              Category Details&nbsp;&nbsp;
              <button
                className="icon-clay mr-2"
                onClick={() => editCategory(categoryId, "categoryDetails")}
              >
                <img src={editIcon} alt="Edit Category" />
              </button>
            </h1>
          </div>
          <div className="row mt-4">
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 border-end pe-2">
                  <p className="font-13 mb-0">Category Name</p>
                  <div className="bg-slash font-14">
                    {categoryDetails.name || "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Languages */}
        <div className="card-body">
          <div className="mb-2">
            <h1 className="fprimary">Languages&nbsp;&nbsp;</h1>
          </div>
          <div className="row .ms-4">
            {categoryDetails.languages &&
            categoryDetails.languages.length > 0 ? (
              categoryDetails.languages.map((languageItem, index) => (
                <div className="col-md-6" key={languageItem._id}>
                  <div className="d-flex justify-content-between indect">
                    <div className="left-box w-100 pe-2">
                      <p className="font-13 mb-0">
                        Language ({languageItem.language})
                      </p>
                      <div className="bg-slash font-14">
                        {languageItem.value}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12">
                <div className="bg-slash font-14">No languages available</div>
              </div>
            )}
          </div>
          <img
            src={categoryDetails.image}
            alt="Product"
            className="img-thumbnail m-2"
            style={{ width: "100px", height: "100px" }}
          />
        </div>

        {/* Created and Updated Timestamps */}
        <div className="card-body">
          <div className="row mt-4">
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 pe-2">
                  <p className="font-13 mb-0">Active</p>
                  <div className="bg-slash font-14">
                    {categoryDetails.isActive ? "Yes" : "No"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 pe-2">
                  <p className="font-13 mb-0">Allowed in Subscription</p>
                  <div className="bg-slash font-14">
                    {categoryDetails.isAllowedInSubscription ? "Yes" : "No"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewCategories;
